module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageHeader.eec170dd.template\";"